<!-- 投诉案件申请 -->
<template>
  <div class="rightApplication">
    <div class="nav-top">
      <i class="iconfont icon-zglsfanhui" @click="toIndex()"></i>
      投诉案件申请
    </div>
    <div class="application introduce" v-if="!applicationNumber && !isAgree">
      <div v-html="introduce"></div>
      <div class="introduce-btn">
        <el-button type="primary" @click="isAgree = true">同意</el-button>
      </div>
    </div>
    <div class="application" v-if="!applicationNumber && isAgree">
      <div class="application-item">
        <div class="application-title">
          <img src="../assets/images/rect.png" alt="" />
          申请人
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          label-position="top"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="姓名" prop="complainantName">
            <el-input
              v-model="ruleForm.complainantName"
              placeholder="请输入您的姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="complainantGender">
            <el-radio-group v-model="ruleForm.complainantGender">
              <el-radio label="MALE">男</el-radio>
              <el-radio label="FEMALE">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="联系电话" prop="complainantMobile">
            <el-input
              placeholder="请输入联系电话"
              v-model="ruleForm.complainantMobile"
            >
              <template slot="prepend">+86</template>
            </el-input>
          </el-form-item>
          <el-form-item label="省（区、市）" prop="address">
            <el-cascader
              v-model="ruleForm.address"
              :options="options"
              @change="handleChange"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="身份证号" prop="complainantIdNumber">
            <el-input
              v-model="ruleForm.complainantIdNumber"
              placeholder="请输入您的身份证号"
            ></el-input>
          </el-form-item>
          <el-form-item label="所在单位" prop="complainantOrg">
            <el-input
              v-model="ruleForm.complainantOrg"
              placeholder="请输入单位"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系地址" prop="complainAddress">
            <el-input
              v-model="ruleForm.complainAddress"
              placeholder="请输入您的联系地址"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="application-item">
        <div class="application-title">
          <img src="../assets/images/rect.png" alt="" />
          被投诉人
        </div>
        <el-form
          :model="tortForm"
          :rules="tortRules"
          label-position="top"
          ref="tortForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="姓名" prop="respondentName">
            <el-input
              v-model="tortForm.respondentName"
              placeholder="请输入被投诉人姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="respondentGender">
            <el-radio-group v-model="tortForm.respondentGender">
              <el-radio label="MALE">男</el-radio>
              <el-radio label="FEMALE">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="执业证号" prop="respondentLicenseNumber">
            <el-input
              v-model="tortForm.respondentLicenseNumber"
              placeholder="请输入被投诉人的执业证件号码"
            ></el-input>
          </el-form-item>
          <el-form-item label="所在律师事务所" prop="respondentOrg">
            <el-input
              v-model="tortForm.respondentOrg"
              placeholder="请输入被投诉人所在律师事务所"
            ></el-input>
          </el-form-item>
          <el-form-item label="省（区、市）" prop="address">
            <el-cascader
              v-model="tortForm.address"
              :options="options"
              @change="handleChange"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="联系电话" prop="respondentMobile">
            <el-input
              placeholder="请输入被投诉人联系电话"
              v-model="tortForm.respondentMobile"
            >
              <template slot="prepend">+86</template>
            </el-input>
          </el-form-item>
          <el-form-item label="联系地址" prop="respondentAddress">
            <el-input
              v-model="tortForm.respondentAddress"
              placeholder="请输入被投诉人联系地址"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="application-item">
        <div class="application-title">
          <img src="../assets/images/rect.png" alt="" />
          投诉信息
        </div>
        <el-form
          :model="infoForm"
          label-position="top"
          ref="infoForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="投诉内容" prop="complainContent">
            <el-input
              type="textarea"
              v-model="infoForm.complainContent"
              placeholder="请输入投诉内容相关信息"
            ></el-input>
          </el-form-item>
          <el-form-item label="投诉要求" prop="complainRequire">
            <el-input
              type="textarea"
              v-model="infoForm.complainRequire"
              placeholder="请输入投诉要求相关信息"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input
              type="textarea"
              v-model="infoForm.remark"
              placeholder="请输入备注信息"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="application-item">
        <div class="application-title">
          <img src="../assets/images/rect.png" alt="" />
          证据上传
        </div>
        <div class="upload-text">支持png、jpg、jpeg，不大于2M</div>
        <el-upload
          :action="uploader.url"
          list-type="picture-card"
          accept="image/*"
          :file-list="fileList"
          :on-change="fileListChange"
          :before-upload="beforeAvatarUpload"
          :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
        <div class="code-box">
          验证码：
          <el-input v-model="code" placeholder="验证码"></el-input>
          <img :src="codeUrl" alt="" />
          <span @click="refreshCode">看不清？</span>
        </div>
      </div>

      <div class="button-box">
        <el-button
          class="buttom-item buttom-submit"
          @click="submitForm('ruleForm')"
          >提 交</el-button
        >
      </div>
    </div>
    <div class="application-success" v-if="applicationNumber && isAgree">
      <i class="iconfont icon-zglschoose"></i>
      <p>登记编号：{{ applicationNumber }}</p>
    </div>
  </div>
</template>

<script>
import api from "../api/index";
import city from "../api/city";

export default {
  data() {
    return {
      isAgree: false,
      introduce: "",
      fileList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      uploader: {
        url: "/service/rest/tk.File/collection/upload",
      },
      proof: [],
      code: "",
      codeUrl: "/captchacircle",
      options: [],
      ruleForm: {
        complainantName: "",
        complainantGender: "",
        complainantMobile: "",
        complainantIdNumber: "",
        complainantOrg: "",
        complainAddress: "",
        address: [],
      },
      rules: {
        complainantName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        complainantGender: [
          { required: true, message: "请选择性别", trigger: "change" },
        ],
        complainantMobile: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
        complainantIdNumber: [
          { required: true, message: "请输入执业证号", trigger: "blur" },
        ],
        complainantOrg: [
          { required: true, message: "请输入所在律师事务所", trigger: "blur" },
        ],
        complainAddress: [
          { required: true, message: "请输入联系地址", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请选择省（区、市）", trigger: "change" },
        ],
      },
      infoForm: {
        complainContent: "",
        complainRequire: "",
        remark: "",
      },
      tortForm: {
        respondentName: "",
        respondentGender: "",
        respondentLicenseNumber: "",
        respondentMobile: "",
        respondentOrg: "",
        respondentAddress: "",
        address: [],
      },
      tortRules: {
        respondentName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        respondentGender: [
          { required: true, message: "请选择性别", trigger: "change" },
        ],
        respondentLicenseNumber: [
          { required: true, message: "请输入执业证号", trigger: "blur" },
        ],
        respondentMobile: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
        respondentOrg: [
          { required: true, message: "请输入所在律师事务所", trigger: "blur" },
        ],
        respondentAddress: [
          { required: true, message: "请输入联系地址", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请选择省（区、市）", trigger: "change" },
        ],
      },
      applicationNumber: "",
    };
  },
  created() {
    this.options = this.formatCitylist(city.citylist);
    this.getCatalogInfo();
  },
  methods: {
    getCatalogInfo() {
      let params = {
        catalogId: "6b78464fec5442bcb4fe56074f89a655",
      };
      api.getCatalogInfo(params).then((res) => {
        if (res.data.code === 1) {
          this.introduce = res.data.result.introduce;
        } else {
          this.$message.error(res.data.description);
        }
      });
    },
    refreshCode() {
      this.codeUrl += "?v=" + new Date().getTime();
      this.code = "";
    },
    formatCitylist(arr, level = 1) {
      for (let i = 0; i < arr.length; i++) {
        const item = arr[i];
        item.label = item.p || item.n || item.s;
        item.value = item.p || item.n || item.s;
        if (item.c && item.c.length > 0)
          item.children = this.formatCitylist(item.c, level + 1);
        if (item.a && item.a.length > 0)
          item.children = this.formatCitylist(item.a, level + 1);
        if (item.children && item.children.length === 0) delete item.children;
      }
      return arr;
    },
    handleChange(value) {
      console.log(value);
    },
    submitForm() {
      let arr = ["ruleForm", "tortForm", "infoForm"];
      arr.forEach((item) => {
        this.$refs[item].validate((valid) => {
          if (!valid) {
            console.error("error submit!!");
            return false;
          }
        });
      });
      this.applicationCreate();
    },
    applicationCreate() {
      if (this.fileList.length !== 0) {
        this.fileList.forEach((item) => {
          this.proof.push(item.response.fileId);
        });
      } else {
        this.$message.warning("请上传证据");
        return;
      }
      if (!this.code) {
        this.$message.warning("请填写验证码");
        return;
      }
      let params = {
        ...this.ruleForm,
        ...this.tortForm,
        ...this.infoForm,
        complainProv: this.ruleForm.address[0],
        complainCity: this.ruleForm.address[1],
        complainDist: this.ruleForm.address[2] || "",
        respondentProv: this.tortForm.address[0],
        respondentCity: this.tortForm.address[1],
        respondentDist: this.tortForm.address[2] || "",
        proof: this.proof,
        code: this.code,
      };
      delete params.address;
      const formData = new FormData();
      Object.keys(params).map((key) => {
        formData.append(key, params[key]);
      });
      api.complaintCreate(params).then((res) => {
        if (res.data.code === 1) {
          this.applicationNumber = res.data.description;
        } else {
          this.$message.warning(res.data.description);
        }
      });
    },
    beforeAvatarUpload(beforeFile) {
      let totalSize =
        this.fileList.reduce((total, file) => total + file.size, 0) +
        beforeFile.size;
      const isLt2M = totalSize / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.warning("上传图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    fileListChange(file, fileList) {
      this.fileList = fileList;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    toIndex() {
      this.$router.push({
        name: "complainView",
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.rightApplication {
  width: 100%;
  height: 100%;
  background: #f4f6fa;
  overflow: hidden;
  .nav-top {
    position: relative;
    width: 100%;
    height: 2.75rem;
    background: #fff;
    text-align: center;
    font-weight: 600;
    font-size: 1.06rem;
    color: #323233;
    line-height: 2.75rem;
    .iconfont {
      position: absolute;
      left: 1rem;
      top: 0;
      font-size: 1.25rem;
      color: #323233;
    }
  }

  .application {
    width: 100%;
    height: calc(100% - 2.75rem);
    box-sizing: border-box;
    overflow: auto;
    background: #f4f6fa;

    .application-item {
      margin-top: 0.75rem;
      padding: 0.81rem 1rem;
      background-color: #fff;
      .application-title {
        width: 100%;
        height: 3rem;
        font-weight: 500;
        font-size: 1rem;
        color: rgba(0, 0, 0, 0.85);
        line-height: 3rem;
        img {
          margin-right: 0.44rem;
          width: 0.38rem;
          height: 0.81rem;
        }
      }
      .upload-text {
        margin-bottom: 1rem;
        font-size: 0.88rem;
        color: rgba(0, 0, 0, 0.45);
        line-height: 1.25rem;
      }
      :deep .el-form-item__label {
        font-weight: 500;
        font-size: 0.88rem;
        color: #171819;
      }
      :deep .el-form-item__label:before {
        color: #4d8ef1;
      }
      :deep .el-cascader {
        width: 100%;
      }
      :deep .el-upload {
        width: 4.5rem;
        height: 4.5rem;
        background: #ffffff;
        border-radius: 0.25rem;
        border: 0.03rem solid rgba(23, 24, 25, 0.2);
      }
      :deep .el-upload--picture-card {
        line-height: 4.8rem;
      }
      :deep .el-upload-list--picture-card .el-upload-list__item {
        width: 4.5rem;
        height: 4.5rem;
      }
      :deep .el-upload-list__item {
        line-height: 0;
      }
      .code-box {
        position: relative;
        margin-top: 1rem;
        font-weight: 500;
        font-size: 0.88rem;
        color: #171819;
        .el-input {
          margin-right: 4px;
          width: 30%;
        }
        img {
          position: absolute;
          top: 0;
          right: 4.4rem;
          width: 30%;
          height: 100%;
        }
        span {
          position: absolute;
          top: 8px;
          right: 0;
          font-size: 14px;
          color: #f27f02;
        }
      }
    }
    .button-box {
      margin: 0 auto;
      margin-top: 1.25rem;
      margin-bottom: 2.06rem;
      width: 19.44rem;
      .buttom-item {
        margin-bottom: 0.75rem;
        width: 100%;
        height: 2.63rem;
        font-weight: 500;
        font-size: 1rem;
        color: #055ad7;
        line-height: 1.38rem;
        background: #ffffff;
        border-radius: 0.25rem;
        border: 0.06rem solid #055ad7;
      }
      .buttom-submit {
        margin-left: 0;
        color: #fff;
        background: #055ad7;
      }
    }
  }
  .introduce {
    margin-top: 1rem;
    background-color: #fff;
    padding-bottom: 3rem;
    .introduce-btn {
      margin-top: 1rem;
      text-align: center;
    }
  }
  .application-success {
    margin: 0 auto;
    margin-top: 7rem;
    text-align: center;
    .iconfont {
      font-size: 5rem;
      color: #5cbc2d;
    }
  }
}
</style>
